import { render, staticRenderFns } from "./ChoiceCreate.vue?vue&type=template&id=1860025a&scoped=true"
import script from "./ChoiceCreate.vue?vue&type=script&lang=js"
export * from "./ChoiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860025a",
  null
  
)

export default component.exports